import React, { createContext, useContext, useState, useCallback } from 'react';

const AllDataContext = createContext();

export const useAllData = () => useContext(AllDataContext);

export const AllDataProvider = ({ children }) => {
  const [allData, setAllDataInternal] = useState({
    persons: [],
    emails: [],
    phones: [],
    addresses: [],
    vehicles: [],
    licensePlates: [],
    devices: [],
    scans: [],
    ipAddresses: [],
    signals: [],
    darkDocs: [],
    poi: [],
    ballistics: [],
    timingAdvance: [],
    metaWarrant: [],
    relativesAssociates: [],
    accounts: [],
    sexOffenders: [],
    linkedData: [],
    whatsHere: [],
    bulkSignals: [],
    bulkSignalsData: [],
    imbs: [],
    icac: [],
    rmsCases: [],
    cadEvents: [],
  });

  const [multiSelected, setMultiSelected] = useState([]);

  const toggleObject = useCallback((object) => {
    setMultiSelected((prevSelected) => {
      if (prevSelected.some((item) => item._id === object._id)) {
        return prevSelected.filter((item) => item._id !== object._id);
      } else {
        return [...prevSelected, object];
      }
    });
  }, []);

  const toggleSelectAll = (category, selectAll) => {
    if (selectAll) {
      setMultiSelected(allData[category]);
    } else {
      setMultiSelected([]);
    }
  };

  const setAllData = useCallback((newDataOrFunction) => {
    setAllDataInternal((prevData) => {
      const newData =
        typeof newDataOrFunction === 'function'
          ? newDataOrFunction(prevData)
          : newDataOrFunction;

      const updatedData = { ...prevData };

      // track removed IDs for each category in prevData
      const removedIds = new Set();

      Object.keys(newData).forEach((category) => {
        if (Array.isArray(newData[category])) {
          const uniqueItems = {};
          const currentIds = new Set(newData[category].map((item) => item && item._id).filter(Boolean));

          // collect IDs of items that exist in prevData but are absent in newData
          prevData[category]?.forEach((item) => {
            if (item && item._id && !currentIds.has(item._id)) {
              removedIds.add(item._id);
            }
          });

          // add unique items from newData[category] to updatedData
          newData[category].forEach((item) => {
            if (item && item._id) {
              uniqueItems[item._id] = item;
            }
          });

          updatedData[category] = Object.values(uniqueItems);
        } else {
          updatedData[category] = newData[category];
        }
      });

      // filter linkedData to remove entries with _id in removedIds (items rmoved from allData)
      updatedData.linkedData = updatedData.linkedData.filter(
        (link) => !removedIds.has(link._id)
      );

      return updatedData;
    });
  }, []);

  return (
    <AllDataContext.Provider value={{ allData, setAllData, multiSelected, toggleObject, toggleSelectAll }}>
      {children}
    </AllDataContext.Provider>
  );
};

/*
    // seems unused, removed and stashed here for later use. - csj

        else if (category === 'relativesAssociates') {
            const uniqueItems = {};
            const personsTahoeIds = new Set(
              prevData.persons.flatMap((person) =>
                person.externalIds ? person.externalIds.map((id) => id.tahoeId) : []
              )
            );
  
            [...(prevData[category] || []), ...newData[category]].forEach((item) => {
              if (item && item.externalIds && item.externalIds.length > 0) {
                item.externalIds.forEach((externalId) => {
                  if (externalId.tahoeId && !personsTahoeIds.has(externalId.tahoeId)) {
                    uniqueItems[externalId.tahoeId] = item;
                  }
                });
              }
            });
  
            updatedData[category] = Object.values(uniqueItems);
          }
*/